import { render } from "./CompleteApprovalPendingCases.vue?vue&type=template&id=c322843e"
import script from "./CompleteApprovalPendingCases.vue?vue&type=script&lang=js"
export * from "./CompleteApprovalPendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/CompleteApprovalPendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c322843e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c322843e', __exports__)) {
    console.log('reload')
    api.reload('c322843e', __exports__)
  }
  
  module.hot.accept("./CompleteApprovalPendingCases.vue?vue&type=template&id=c322843e", () => {
    console.log('re-render')
    api.rerender('c322843e', render)
  })

}


export default __exports__